module.exports = __webpack_public_path__ + "static/media/search-solid-r.f9d14772.svg";